import {Card, Divider, Grid, Link, SxProps, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {showAmount, SmartLink} from "../abelcommon";
import React from "react";

export function InputItem({ringid, outpoints, serialnumber, sx}: {
    ringid: string,
    outpoints: any,
    serialnumber: string,
    sx?: SxProps | undefined
}) {
    return (
        <Card sx={{
            padding: 1,
            display: 'flex',
            borderRadius: 2,
            border: '1px solid',
            // bgcolor: 'white',
            // height: 400,
            width: 1,
            overflow: 'auto',
            ...sx
        }}>
            <Grid container columns={12} direction="row">
                <Grid item xs={12} md={5}>
                    <Typography variant="body2">
                        {`Ring ID: `}
                        {/*<Link component={RouterLink} to={`/ring/0x${ringid}`}>*/}
                        {ringid.slice(0, 8) + '..' + ringid.slice(-8)}
                        {/*</Link>*/}
                    </Typography>
                </Grid>
                <Grid item xs={0} md={2}>
                    <Typography variant="body2" sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                        {`Ring Size: ${outpoints.length}`}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography variant="body2">
                        {`Serial Number: ${serialnumber.slice(0, 8) + '..' + serialnumber.slice(-8)}`}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Divider orientation="horizontal"/>
                </Grid>

                <Grid item md={12}>
                    <Grid container columns={18} direction="row">
                        <Grid item xs={12} md={5} textAlign={'center'}>txid</Grid>
                        <Grid item xs={6} md={1} textAlign={'center'}>index</Grid>
                        <Grid item md={2} textAlign={'center'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>height</Grid>
                        {/*<Grid item md={4} textAlign={'center'}>blockid</Grid>*/}
                        <Grid item md={6} textAlign={'center'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>address</Grid>
                        <Grid item md={4} textAlign={'center'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>amount (ABEL)</Grid>
                        <Grid item md={18}>
                            <Divider orientation="horizontal"/>
                        </Grid>
                        {outpoints.map((outpoint: any, i: number) => (
                            <React.Fragment key={`${ringid}_outpoint_${i}`}>
                                <Grid item xs={12} md={5} textAlign={'center'}>
                                    <SmartLink to={`/tx/0x${outpoint.txid}`}>
                                        <Typography variant={'body2'} sx={{fontFamily: 'Monospace'}}>
                                            0x{outpoint.txid.slice(0, 8) + '..' + outpoint.txid.slice(-8)}
                                        </Typography>
                                    </SmartLink>
                                </Grid>
                                <Grid item xs={6} md={1} textAlign={'center'}>
                                    <Typography variant={'body2'} sx={{fontFamily: 'Monospace'}}>
                                        {outpoint.index}
                                    </Typography>
                                </Grid>
                                <Grid item md={2} textAlign={'center'} sx={{
                                    display: {
                                        xs: 'none', // theme.breakpoints.up('sm')
                                        sm: 'none', // theme.breakpoints.up('sm')
                                        md: 'table-cell', // theme.breakpoints.up('md')
                                        // lg: 'table-cell', // theme.breakpoints.up('lg')
                                        // xl: 'table-cell', // theme.breakpoints.up('xl')
                                    }
                                }}>
                                    <SmartLink to={`/block/${outpoint.blockheight}`}>{outpoint.blockheight}</SmartLink>
                                </Grid>
                                {/*<Grid item md={4} textAlign={'center'}>*/}
                                {/*    <SmartLink to={`/block/${outpoint.blockid}`}>*/}
                                {/*        <Typography variant={'body2'} sx={{fontFamily: 'Monospace'}}>*/}
                                {/*            0x{outpoint.blockid.slice(0, 8) + '..' + outpoint.blockid.slice(-8)*/}
                                {/*        </Typography>*/}
                                {/*    </SmartLink>*/}
                                {/*</Grid>*/}
                                <Grid item md={6} textAlign={'center'} sx={{
                                    display: {
                                        xs: 'none', // theme.breakpoints.up('sm')
                                        sm: 'none', // theme.breakpoints.up('sm')
                                        md: 'table-cell', // theme.breakpoints.up('md')
                                        // lg: 'table-cell', // theme.breakpoints.up('lg')
                                        // xl: 'table-cell', // theme.breakpoints.up('xl')
                                    }
                                }}>
                                    <Typography variant="body2">
                                        <Link component={RouterLink} to={`/address/0x${outpoint.address}`}>
                                            {outpoint.address.slice(0, 8) + '..' + outpoint.address.slice(-8)}
                                            {/*{outpoint.address}*/}
                                            {outpoint.address && '*'.repeat(6)}
                                        </Link>
                                    </Typography>
                                </Grid>
                                <Grid item md={4} textAlign={'center'} sx={{
                                    display: {
                                        xs: 'none', // theme.breakpoints.up('sm')
                                        sm: 'none', // theme.breakpoints.up('sm')
                                        md: 'table-cell', // theme.breakpoints.up('md')
                                        // lg: 'table-cell', // theme.breakpoints.up('lg')
                                        // xl: 'table-cell', // theme.breakpoints.up('xl')
                                    }
                                }}>
                                    <Typography variant={'body2'} sx={{fontFamily: 'Monospace'}}>
                                        {showAmount(outpoint.privacylevel, outpoint.amount)}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
}

export function OutputsItem(
    {outputs, sx}:
    {
        outputs: any,
        sx?: SxProps | undefined
    }) {
    return (
        <Card
            sx={{
                display: 'flex',
                py: 1,
                px: 0,
                borderRadius: 2,
                // border: '1px solid',
                width: 1,
                ...sx
            }}>
            <Grid container direction="row" columns={16}>
                <Grid item xs={16} md={16}>
                </Grid>
                <Grid item xs={9} md={9} textAlign={'center'}>
                    <Typography variant="body2" paragraph>
                        address
                    </Typography>
                </Grid>
                <Grid item xs={7} md={7} textAlign={'center'}>
                    <Typography variant="body2">
                        amount (ABEL)
                    </Typography>
                </Grid>
                <Grid item xs={16} md={16}>
                    <Divider orientation="horizontal"/>
                </Grid>
                {outputs.map((output: any, i: any) => {
                    return (
                        <Card
                            key={`${output.txid}_output_${output.index}`}
                            sx={{
                                display: 'flex',
                                padding: 1,
                                borderRadius: 2,
                                border: '1px solid',
                                width: 1
                            }}>
                            <React.Fragment key={`${output.address}`}>
                                <Grid item xs={9} md={9} textAlign={'center'}>
                                    <SmartLink to={`/address/0x${output.address}`}>
                                        <Typography variant={'body2'} sx={{fontFamily: 'Monospace'}}>
                                            {output.address.slice(0, 8) + '..' + output.address.slice(-8) + '*'.repeat(6)}
                                        </Typography>
                                    </SmartLink>
                                </Grid>
                                <Grid item xs={7} md={7} textAlign={'center'}>
                                    <Typography variant="body2">
                                        {showAmount(output.privacylevel, output.amount)}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        </Card>);
                })}
            </Grid>
        </Card>
    );
}
